export default (bet, gameType) => {
  let tempBet = null
  let betFormatted = null

  switch (gameType) {
    case 'tens':
      tempBet = bet.split(' - ')
      betFormatted = tempBet[0].split(' ') || []
      break
    case 'supersete':
      tempBet = bet.split(' ')
      betFormatted = {
        1: [],
        2: [],
        3: [],
        4: [],
        5: [],
        6: [],
        7: []
      }

      tempBet.forEach((a) => {
        const b = a.split('')
        betFormatted[b[0]].push(Number(b[1]))
        betFormatted[b[0]].sort()
      })
      break
    case 'loteca':
      tempBet = {}

      bet.split('').forEach((val, index) => {
        switch (val) {
          case '1':
            tempBet[index] = { 0: false, 1: false, 2: true }
            break
          case '2':
            tempBet[index] = { 0: false, 1: true, 2: false }
            break
          case '3':
            tempBet[index] = { 0: false, 1: true, 2: true }
            break
          case '4':
            tempBet[index] = { 0: true, 1: false, 2: false }
            break
          case '5':
            tempBet[index] = { 0: true, 1: false, 2: true }
            break
          case '6':
            tempBet[index] = { 0: true, 1: true, 2: false }
            break
          case '7':
            tempBet[index] = { 0: true, 1: true, 2: true }
            break
        }
      })

      betFormatted = tempBet

      break
    case 'federal':
      betFormatted = bet.split(' ')
      break
  }

  return betFormatted
}
